import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Portfolio from './pages/Portfolio';
import Process from './pages/Process';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';

// Service Pages
import GoogleAds from './pages/services/GoogleAds';
import LocalSEO from './pages/services/LocalSEO';
import TechnicalSEO from './pages/services/TechnicalSEO';
import Analytics from './pages/services/Analytics';

// Global Styles
const GlobalStyles = () => (
  <style>{`
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif; }
    html { scroll-behavior: smooth; }
    
    @keyframes fadeInUp {
      from { opacity: 0; transform: translateY(30px); }
      to { opacity: 1; transform: translateY(0); }
    }
    
    @keyframes float {
      0%, 100% { transform: translateY(0px); }
      50% { transform: translateY(-20px); }
    }
    
    @keyframes spin {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
    
    .btn-primary {
      background: linear-gradient(135deg, #ff6b35 0%, #f54e00 100%);
      transition: all 0.3s ease;
      border: none;
      cursor: pointer;
      color: white;
      font-weight: 600;
    }
    
    .btn-primary:hover {
      transform: translateY(-2px);
      box-shadow: 0 10px 40px rgba(255, 107, 53, 0.4);
    }
    
    .btn-secondary {
      background: transparent;
      border: 2px solid #ff6b35;
      color: #ff6b35;
      transition: all 0.3s ease;
      cursor: pointer;
      font-weight: 600;
    }
    
    .btn-secondary:hover {
      background: #ff6b35;
      color: white;
    }
    
    .card:hover {
      transform: translateY(-8px);
      box-shadow: 0 20px 40px rgba(0,0,0,0.12);
    }
    
    ::-webkit-scrollbar { width: 10px; }
    ::-webkit-scrollbar-track { background: #f1f1f1; }
    ::-webkit-scrollbar-thumb { background: #ff6b35; border-radius: 5px; }
    
    a { text-decoration: none; color: inherit; }
  `}</style>
);

function App() {
  return (
    <Router>
      <GlobalStyles />
      <ScrollToTop />
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Navbar />
        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/process" element={<Process />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            
            {/* Service Pages */}
            <Route path="/services/google-ads" element={<GoogleAds />} />
            <Route path="/services/local-seo" element={<LocalSEO />} />
            <Route path="/services/technical-seo" element={<TechnicalSEO />} />
            <Route path="/services/analytics" element={<Analytics />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
